<template>
  <div class="chart-dialog">
    <el-dialog
      title="多次考试名次对比"
      :visible.sync="examRankComparisonSelectDialogShow"
      width="500px"
      :before-close="dialogClose"
    >
      <div
        style="
          width: 200px;
          margin: 0 auto 5px;
          display: flex;
          align-items: center;
        "
        v-for="(item, index) in examRankList"
        :key="index"
      >
        <span style="width: 120px">指定名次：</span
        ><el-input v-model="item.rankVal" placeholder="请输入名次"></el-input>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 50px">
        <el-button type="primary" @click="addRank">添加</el-button>
        <el-button type="primary" @click="selectExamRankConfirm"
          >下一步</el-button
        >
        <el-button type="primary" @click="delRank">删除</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["examRankComparisonSelectDialogShow"],
  data() {
    return {
      examRankList: [
        {
          rankVal: "",
        },
      ], // 考试名次列表
    };
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:examRankComparisonSelectDialogShow", false);
    },
    selectExamRankConfirm() {
      if (this.examRankList.some((item) => item.rankVal == "")) {
        this.$message.warning("请输入名次");
        return;
      }
      this.$emit("update:examRankComparisonSelectDialogShow", false);
      this.$emit("selectExamRankConfirm", this.examRankList);
    },
    addRank() {
      this.examRankList.push({
        rankVal: "",
      });
    },
    delRank() {
      if (this.examRankList.length > 1) {
        this.examRankList.pop();
      } else {
        this.$message.warning("至少保留一个名次");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./examRankComparisonSelectDialog.scss";
</style>